module.exports = __webpack_public_path__ + "img/pharmacybldg-h-474x356.5f380f02.jpg";